const hideItems = [
  'usersReports',
  'eventsReports',
  'groupsReports',
  'recorderIp',
  'recorderAnalogic',
  'recorderRecordings',
  'ivrs',
  'ivrsConfig',
  'groupsConfig'
];

export default hideItems;
